var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('UserActionsWrap',{attrs:{"form-title":"Log in<br> to your account"}},[_c('LoginForm')],1),_c('UserActionsNavigation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }